import { render, staticRenderFns } from "./suspension.vue?vue&type=template&id=4a97d6c0&scoped=true"
import script from "./suspension.vue?vue&type=script&lang=js"
export * from "./suspension.vue?vue&type=script&lang=js"
import style1 from "./suspension.vue?vue&type=style&index=1&id=4a97d6c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97d6c0",
  null
  
)

export default component.exports